import Moment from 'moment';
import { HOME_TODAY_SCREEN, SAMPLE_TO_SALE_SCREEN, API_CONSTANTS, APP_CONSTANTS, COMMON } from './Constants';
import { ActivityType, S2S_STAGE } from './Enum';
import { toast } from 'react-toastify';
import AuthService from '../providers/AuthService';
import moment from 'moment';

export default class Utilities {

    static isDebugMode = (process.env.NODE_ENV === "development");

    static LogPrint(title = "", ...params) {
        if (this.isDebugMode && title !== null && title.length > 0) {
            if (params.length > 0) {
                console.log(title, ...params);
            } else {
                console.log(title);
            }
        }
    }

    static checkLogin() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            return true;
        }
        return false;
    }

    static setRetailer(retailer) {
        localStorage.setItem(APP_CONSTANTS.RETAILER, JSON.stringify(retailer));
    }

    static getRetailer() {
        const item = JSON.parse(localStorage.getItem(APP_CONSTANTS.RETAILER));
        return item;
    }

    static setNotificationCount(count) {
        localStorage.setItem(APP_CONSTANTS.NOTIFICATION_COUNT, count);
    }

    static getNotificationCount() {
        const count = JSON.parse(localStorage.getItem(APP_CONSTANTS.NOTIFICATION_COUNT));
        return count;
    }

    static downloadBlob(blob, name) {
        // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
        const blobUrl = URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement("a");

        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;

        // Append link to the body
        document.body.appendChild(link);

        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        );

        // Remove link from body
        document.body.removeChild(link);
    }

    static getCurrentDate() {
        //var today = new Date(),
        //date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        //return date;
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd
        return today;
    }

    static getTimeAmPm() {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    static getSyncDate() {
        return Moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    }

    static formatDate(date) {
        return Moment(new Date(date)).format("DD/MM/YYYY");
    }

    static calenderFormatDate(date) {
        return Moment(new Date(date)).format("YYYY-MM-DD");
    }


    static getUrlFromByteArray = (byte_array) => {
        var blob = new Blob([byte_array], { type: "image/jpeg" });
        var url = URL.createObjectURL(blob);
        return url;
    }

    static async createFile(url) {
        let response = await fetch(url);
        let data = await response.blob();
        let metadata = {
            type: 'image/jpeg'
        };
        let file = new File([data], "test.jpg", metadata);
        return file;
    }

    static arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    static getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";
            // Make new FileReader
            let reader = new FileReader();
            // Convert the file to base64 text
            reader.readAsDataURL(file);
            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    static calculateAge = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }
        var ageIs = "( " + age_now + " Year )";
        return ageIs;
    }

    static isNetworkConnected() {
        return window.navigator.onLine ? true : false;
    }


    static convertByteArrayToFile = (byteArray, mimeType, fileName) => {
        let file = new File(byteArray, fileName, { type: mimeType, lastModified: Date.now() });
        return file;
    }


    static async getImageBytesFromUrl(imageUrl) {
        //Utilities.LogPrint("getImageBytesFromUrl:Started", (new Date()).getMilliseconds());
        try {
            const response = await fetch(imageUrl);
            if (response.status === 200) {
                const blob = await response.blob();
                if (blob !== null) {
                    return await blob?.arrayBuffer().then(result => {
                        const array = new Uint8Array(result);
                        return array;
                    });
                } else {
                    //Utilities.LogPrint("getImageBytesFromUrl:Failed", "Unable to Fetch Image");
                }
            }
        } catch (error) {
            //Utilities.LogPrint("getImageBytesFromUrl:Catch", error);
        }

        return null;
    }

    static convertUTCDateToLocalDate(date1) {
        var date = new Date(date1);
        var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
        return newDate;
    }

    static activityTag(number) {
        if (number <= 9999) { number = ("0000" + number).slice(-5); }
        return number;
    }


    static async getUserLocation() {
        let latLng = {
            latitude: null,
            longitude: null
        }
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const coords = position.coords;

                let latLng = {
                    latitude: coords.latitude.toFixed(6),
                    longitude: coords.longitude.toFixed(6)
                };
                return latLng;

            }, (error) => {
                console.error("Error Code = " + error.code + " - " + error.message);
                return latLng;
            });
        }
        return latLng;
    }


    static secondsToTime(secs) {
        const hours = Math.floor(secs / (60 * 60));

        const divisor_for_minutes = secs % (60 * 60);
        const minutes = Math.floor(divisor_for_minutes / 60);

        const divisor_for_seconds = divisor_for_minutes % 60;
        const seconds = Math.ceil(divisor_for_seconds);

        const obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    static getActivityTypeName(activityTypeId) {
        switch (activityTypeId) {
            case ActivityType.INDIVIDUAL_VISIT:
                return HOME_TODAY_SCREEN.INDIVIDUAL_VISIT;

            case ActivityType.SAMPLE_DISTRIBUTION:
                return HOME_TODAY_SCREEN.SAMPLE_DISTRIBUTION;

            case ActivityType.GROUP_MEETING:
                return HOME_TODAY_SCREEN.GROUP_MEET;

            default:
                break;
        }
    }

    static getActivityStageName(stageId) {
        switch (stageId) {
            case S2S_STAGE.SOWING:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.SOWING;

            case S2S_STAGE.TRANSPLANTATION:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION;

            case S2S_STAGE.PLOT_VISIT:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.PLOT_VISIT;

            case S2S_STAGE.FIELD_DAY:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.FIELD_DAY;

            case S2S_STAGE.HARVEST_DETAILS:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS;

            case S2S_STAGE.GERMINATION:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.GERMINATION;

            case S2S_STAGE.FRUIT_QUALITY:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY;

            case S2S_STAGE.PEST_AND_DISEASE:
                return HOME_TODAY_SCREEN.SAMPLE_TO_SALE + " - " + SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE;

            default:
                break;
        }
    }

    static formatDatePPT = (date) => {
        return moment(new Date(date)).format("DD/MM/YYYY HH:mm");
    }

    static getPercentageWidth(totalWidth, total, active) {
        return (active * totalWidth) / total;
    }

    static getActiveUsersPercent(totalUser, activeUser) {

        if (totalUser > 0) {
            const percent = (activeUser * 100) / totalUser;
            return Math.round(percent) + "%";
        } else {
            return 0 + "%";
        }
    }

    static tokenExpiredRedirectToLogin() {
        toast.configure();
        toast.error(COMMON.TOKEN_EXPIRED);
        setTimeout(() => {
            localStorage.removeItem(API_CONSTANTS.ACCESS_TOKEN);
            localStorage.removeItem(APP_CONSTANTS.APP_USER);
            //localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, null);
            //localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, null);
            window.location.reload();
        }, 1000);
    }

    static createWelcomeSlide(pptx) {
        let welcomeSlide = pptx.addSlide({ sectionTitle: "Welcome" });
        welcomeSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        welcomeSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        welcomeSlide.addImage({ path: "/assets/report-icons/slide1-bg.png", x: 0, y: 1, w: 10, h: 4 });
        welcomeSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
        welcomeSlide.addText("SAFAL 2.0 Report", { x: 3, y: 3, w: 3, color: "#fc9803", bold: true, fontSize: 20 });
    }
    static createDetailedSlide(pptx, data, startDate, endDate) {
        let detailSlide = pptx.addSlide({ sectionTitle: "Details" });
        const session = AuthService.getSession();
        detailSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        detailSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        detailSlide.addText("Details", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });

        detailSlide.addText("Downloaded By : " + session?.user?.name, { x: 0.2, y: 2.4, w: 3, color: "#000000", fontSize: 13 });
        detailSlide.addText("Date of Generation: " + Utilities.formatDatePPT(new Date()), { x: 0.2, y: 2.8, w: 4, color: "#000000", fontSize: 13 });
        detailSlide.addText("From Date : " + Utilities.formatDate(startDate), { x: 0.2, y: 3.2, w: 3, color: "#000000", fontSize: 13 });
        detailSlide.addText("Reporting Manager : " + data?.reporting_manager?.name, { x: 4, y: 2.4, w: 3, color: "#000000", fontSize: 13 });
        detailSlide.addText("Sub(based on filter selection): All", { x: 4, y: 2.8, w: 4.5, color: "#000000", fontSize: 13 });
        detailSlide.addText("To Date : " + Utilities.formatDate(endDate), { x: 4, y: 3.2, w: 3, color: "#000000", fontSize: 13 });

        detailSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
    }
    static createKrishakPrerakSlide(pptx, data) {
        let krishakPrerakSlide = pptx.addSlide({ sectionTitle: "Krishak And Prerak" });
        krishakPrerakSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        krishakPrerakSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        krishakPrerakSlide.addText("Krishak And Prerak", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });

        krishakPrerakSlide.addImage({ path: "/assets/report-icons/krishak_general_icon.png", x: 3, y: 2.5, w: 1, h: 1 });
        krishakPrerakSlide.addText("Krishak", { x: 4, y: 2.9, w: 3, color: "#000000", fontSize: 20 });
        krishakPrerakSlide.addText(data.new_krishak, { x: 4.1, y: 3.15, w: 3, color: "#000000", bold: true, fontSize: 20 });
        krishakPrerakSlide.addImage({ path: "/assets/report-icons/krishak_prerak_icon.png", x: 5.3, y: 2.5, w: 1, h: 1 });
        krishakPrerakSlide.addText("Prerak", { x: 6.3, y: 2.9, w: 3, color: "#000000", fontSize: 20 });
        krishakPrerakSlide.addText(data.new_prerak, { x: 6.4, y: 3.15, w: 3, color: "#000000", bold: true, fontSize: 20 });

        krishakPrerakSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });

    }
    static createUserWiseActivitiesSlide(pptx, data) {
        let allActivities = data.user_activity.user_detail;
        let userWiseActivitiesSlide = pptx.addSlide({ sectionTitle: "User Wise Activities" });
        userWiseActivitiesSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        userWiseActivitiesSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        userWiseActivitiesSlide.addText("User Wise Activities", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });

        userWiseActivitiesSlide.addText("Active Users", { x: 2, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        userWiseActivitiesSlide.addText(data.user_activity.active_user + "/" + data.user_activity.total_user, { x: 7.6, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        userWiseActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 2, y: 1.4, w: 6, h: 0.3, fill: { color: "dae2f0" } });
        userWiseActivitiesSlide.addText(Utilities.getActiveUsersPercent(data.user_activity.total_user, data.user_activity.active_user), { x: 2, y: 1.4, w: Utilities.getPercentageWidth(6, data.user_activity.total_user, data.user_activity.active_user), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });

        // userWiseActivitiesSlide.addShape(pptx.ShapeType.rect, { x: 2, y: 2, w: 6.5, h: 1.2 + ((totalUsers * 0.3) + 0.5), fill: { color: "78919c" } });

        userWiseActivitiesSlide.addText("Activities Completed/Planned by Users", { x: 1.5, y: 2.3, w: 3, color: "#000000", bold: true, fontSize: 12 });


        let newSlide;
        if (allActivities.length > 5) {
            newSlide = pptx.addSlide({ sectionTitle: "Sample" });
            newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
            newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
            newSlide.addText("User Wise Activities", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
            newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
        }

        let index = 0;
        for (var i = 0; i < allActivities.length; i++) {
            let activity = allActivities[i];

            if (allActivities.length <= 5) {
                userWiseActivitiesSlide.addText(activity.user_name, { x: 1.5, y: (2.65 + (i * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                userWiseActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                userWiseActivitiesSlide.addText(activity.completed_activity, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, activity.total_activity, activity.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                userWiseActivitiesSlide.addText((activity.total_activity === 0) ? "0" : activity.total_activity, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
            } else {
                if (i <= 4) {
                    userWiseActivitiesSlide.addText(activity.user_name, { x: 1.5, y: (2.65 + (i * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                    userWiseActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                    userWiseActivitiesSlide.addText(activity.completed_activity, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, activity.total_activity, activity.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                    userWiseActivitiesSlide.addText((activity.total_activity === 0) ? "0" : activity.total_activity, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                } else {
                    if (((i - 4) % 7) === 0) {
                        newSlide.addText(activity.user_name, { x: 1.5, y: (1 + (index * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (0.85 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(activity.completed_activity, { x: 3.2, y: (0.85 + (index * 0.5)), w: Utilities.getPercentageWidth(5, activity.total_activity, activity.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((activity.total_activity === 0) ? "0" : activity.total_activity, { x: 8.2, y: (1 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });

                        index = 0;
                        newSlide = pptx.addSlide({ sectionTitle: "Sample" });
                        newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
                        newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
                        newSlide.addText("User Wise Activities", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
                        newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
                        // index++;
                    } else {

                        newSlide.addText(activity.user_name, { x: 1.5, y: (1.2 + (index * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (1.05 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(activity.completed_activity, { x: 3.2, y: (1.05 + (index * 0.5)), w: Utilities.getPercentageWidth(5, activity.total_activity, activity.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((activity.total_activity === 0) ? "0" : activity.total_activity, { x: 8.2, y: (1.2 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                        index++;
                    }
                }
            }
        }

        userWiseActivitiesSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });

    }
    static createCropWiseHybridActivitiesSlide(pptx, hybrid) {
        let cropWiseHybridActivitiesSlide = pptx.addSlide({ sectionTitle: "Crop Wise Hybrid Activities" });

        cropWiseHybridActivitiesSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        cropWiseHybridActivitiesSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        cropWiseHybridActivitiesSlide.addText(hybrid.hybrid_name + " Hybrid Activities", { x: 1, y: 0.4, w: 4, color: "#ffffff", bold: true, fontSize: 18 });

        cropWiseHybridActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 2, y: 1.4, w: 6, h: 0.3, line: "000000" });
        cropWiseHybridActivitiesSlide.addText(hybrid.hybrid_name, { x: 2, y: 1.55, w: 3, color: "#000000", fontSize: 12 });
        cropWiseHybridActivitiesSlide.addImage({ path: "/assets/report-icons/dropdown.svg", rotate: 90, x: 7.8, y: 1.47, w: 0.1, h: 0.15 });

        cropWiseHybridActivitiesSlide.addText("Active Hybrids", { x: 2, y: 2, w: 3, color: "#000000", fontSize: 12 });
        cropWiseHybridActivitiesSlide.addText(hybrid.active_hybrid + "/" + hybrid.total_hybrid, { x: 7.6, y: 2, w: 3, color: "#000000", fontSize: 12 });
        cropWiseHybridActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 2, y: 2.1, w: 6, h: 0.3, fill: { color: "dae2f0" } });
        cropWiseHybridActivitiesSlide.addText(Utilities.getActiveUsersPercent(hybrid.total_hybrid, hybrid.active_hybrid), { x: 2, y: 2.1, w: Utilities.getPercentageWidth(6, hybrid.total_hybrid, hybrid.active_hybrid), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });

        let newSlide;
        if (hybrid.hybrid_detail.length > 5) {
            newSlide = pptx.addSlide({ sectionTitle: "Sample" });
            newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
            newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
            newSlide.addText(hybrid.hybrid_name + " Hybrid Activities", { x: 1, y: 0.4, w: 4, color: "#ffffff", bold: true, fontSize: 18 });
            newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
        }
        let index = 0;
        for (var i = 0; i < hybrid.hybrid_detail.length; i++) {
            let hybridItem = hybrid.hybrid_detail[i];
            if (hybrid.hybrid_detail.length <= 5) {
                cropWiseHybridActivitiesSlide.addText(hybridItem.hybrid_name, { x: 2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                cropWiseHybridActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                cropWiseHybridActivitiesSlide.addText(hybridItem.active_hybrid, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, hybridItem.total_hybrid, hybridItem.active_hybrid), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                cropWiseHybridActivitiesSlide.addText((hybridItem.total_hybrid === 0) ? "0" : hybridItem.total_hybrid, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
            } else {
                if (i <= 4) {
                    cropWiseHybridActivitiesSlide.addText(hybridItem.hybrid_name, { x: 2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                    cropWiseHybridActivitiesSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                    cropWiseHybridActivitiesSlide.addText(hybridItem.active_hybrid, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, hybridItem.total_hybrid, hybridItem.active_hybrid), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                    cropWiseHybridActivitiesSlide.addText((hybridItem.total_hybrid === 0) ? "0" : hybridItem.total_hybrid, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                } else {
                    if (((i - 4) % 7) === 0) {
                        newSlide.addText(hybridItem.hybrid_name, { x: 2, y: (1 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (0.85 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(hybridItem.active_hybrid, { x: 3.2, y: (0.85 + (index * 0.5)), w: Utilities.getPercentageWidth(5, hybridItem.total_hybrid, hybridItem.active_hybrid), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((hybridItem.total_hybrid === 0) ? "0" : hybridItem.total_hybrid, { x: 8.2, y: (1 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });

                        index = 1;
                        newSlide = pptx.addSlide({ sectionTitle: "Sample" });
                        newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
                        newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
                        newSlide.addText("Crop Wise Hybrid Activities", { x: 1, y: 0.4, w: 4, color: "#ffffff", bold: true, fontSize: 18 });
                        newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
                        // index++;
                    } else {
                        newSlide.addText(hybridItem.hybrid_name, { x: 2, y: (1 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (0.85 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(hybridItem.active_hybrid, { x: 3.2, y: (0.85 + (index * 0.5)), w: Utilities.getPercentageWidth(5, hybridItem.total_hybrid, hybridItem.active_hybrid), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((hybridItem.total_hybrid === 0) ? "0" : hybridItem.total_hybrid, { x: 8.2, y: (1 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                        index++;
                    }
                }
            }
        }

        cropWiseHybridActivitiesSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });

    }
    static createActivitiesCompletedSlide(pptx, dataChartAreaLine, data) {
        let activitiesCompletedSlide = pptx.addSlide({ sectionTitle: "Activities Completed" });
        activitiesCompletedSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        activitiesCompletedSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        activitiesCompletedSlide.addText("Activities Completed", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });

        activitiesCompletedSlide.addText("Activities Completed", { x: 2, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        activitiesCompletedSlide.addText(data.activity.completed_activity + "/" + data.activity.total_activity, { x: 7.6, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        activitiesCompletedSlide.addShape(pptx.ShapeType.roundRect, { x: 2, y: 1.4, w: 6, h: 0.3, fill: { color: "dae2f0" } });
        activitiesCompletedSlide.addText(Utilities.getActiveUsersPercent(data.activity.total_activity, data.activity.completed_activity), { x: 2, y: 1.4, w: Utilities.getPercentageWidth(6, data.activity.total_activity, data.activity.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });

        // activitiesCompletedSlide.addShape(pptx.ShapeType.rect, { x: 2, y: 1.8, w: 6, h: 3, fill: { color: "78919c" } });
        activitiesCompletedSlide.addChart(pptx.ChartType.bar, dataChartAreaLine, { x: 2, y: 1.8, w: 6, h: 3 });

        activitiesCompletedSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });

    }
    static createDrillDownSlide(pptx, name, subActivitiesArray, colorCode) {
        let drillDownSlide = pptx.addSlide({ sectionTitle: "Drill Down" });
        drillDownSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        drillDownSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        drillDownSlide.addText(name + " - Drill Down", { x: 1, y: 0.4, w: 4, color: "#ffffff", bold: true, fontSize: 18 });
        // drillDownSlide.addShape(pptx.ShapeType.rect, { x: 1, y: 1.2, w: 8, h: 3, fill: { color: "78919c" } });

        for (var i = 0; i < subActivitiesArray.length; i++) {
            let activityItem = subActivitiesArray[i];
            let index = i;

            drillDownSlide.addText(activityItem.activity_name, { x: 1.3, y: (1.5 + (index * 0.5)), w: 2, color: "#000000", fontSize: 12 });
            drillDownSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (1.35 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
            drillDownSlide.addText(activityItem.completed_activity, { x: 3.2, y: (1.35 + (index * 0.5)), w: Utilities.getPercentageWidth(5, activityItem.total_activity, activityItem.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: colorCode } });
            drillDownSlide.addText((activityItem.total_activity === 0) ? "0" : activityItem.total_activity, { x: 8.2, y: (1.5 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
        }

        drillDownSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
    }
    static createTehsilDataSlide(pptx, data) {
        let tehsilDataSlide = pptx.addSlide({ sectionTitle: "Tehsil Data" });

        let allTehsils = data.tehsil.tehsil_detail;
        tehsilDataSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        tehsilDataSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        tehsilDataSlide.addText("Tehsil Data", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });

        tehsilDataSlide.addText("Active Tehsils", { x: 2, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        tehsilDataSlide.addText(data.tehsil.active_tehsil + "/" + data.tehsil.total_tehsil, { x: 7.6, y: 1.3, w: 3, color: "#000000", fontSize: 12 });
        tehsilDataSlide.addShape(pptx.ShapeType.roundRect, { x: 2, y: 1.4, w: 6, h: 0.3, fill: { color: "dae2f0" } });
        tehsilDataSlide.addText(Utilities.getActiveUsersPercent(data.tehsil.total_tehsil, data.tehsil.active_tehsil), { x: 2, y: 1.4, w: Utilities.getPercentageWidth(6, data.tehsil.total_tehsil, data.tehsil.active_tehsil), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });

        let newSlide;
        if (allTehsils.length > 5) {
            newSlide = pptx.addSlide({ sectionTitle: "Sample" });
            newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
            newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
            newSlide.addText("Tehsil Data", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
            newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
        }

        let index = 0;
        for (var i = 0; i < allTehsils.length; i++) {
            let tehsil = allTehsils[i];

            if (allTehsils.length <= 5) {
                tehsilDataSlide.addText(tehsil.tehsil_name, { x: 1.5, y: (2.65 + (i * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                tehsilDataSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                tehsilDataSlide.addText(tehsil.completed_activity, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, tehsil.total_activity, tehsil.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                tehsilDataSlide.addText((tehsil.total_activity === 0) ? "0" : tehsil.total_activity, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
            } else {
                if (i <= 4) {
                    tehsilDataSlide.addText(tehsil.tehsil_name, { x: 1.5, y: (2.65 + (i * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                    tehsilDataSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (2.5 + (i * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                    tehsilDataSlide.addText(tehsil.completed_activity, { x: 3.2, y: (2.5 + (i * 0.5)), w: Utilities.getPercentageWidth(5, tehsil.total_activity, tehsil.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                    tehsilDataSlide.addText((tehsil.total_activity === 0) ? "0" : tehsil.total_activity, { x: 8.2, y: (2.65 + (i * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                } else {
                    if (((i - 4) % 7) === 0) {
                        newSlide.addText(tehsil.tehsil_name, { x: 1.5, y: (1.2 + (index * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (1 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(tehsil.completed_activity, { x: 3.2, y: (1 + (index * 0.5)), w: Utilities.getPercentageWidth(5, tehsil.total_activity, tehsil.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((tehsil.total_activity === 0) ? "0" : tehsil.total_activity, { x: 8.2, y: (1.2 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });

                        index = 0;
                        newSlide = pptx.addSlide({ sectionTitle: "Sample" });
                        newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
                        newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
                        newSlide.addText("Tehsil Data", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
                        newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
                        // index++;
                    } else {

                        newSlide.addText(tehsil.tehsil_name, { x: 1.5, y: (1.2 + (index * 0.5)), w: 2, color: "#000000", fontSize: 12 });
                        newSlide.addShape(pptx.ShapeType.roundRect, { x: 3.2, y: (1 + (index * 0.5)), w: 5, h: 0.3, fill: { color: "dae2f0" } });
                        newSlide.addText(tehsil.completed_activity, { x: 3.2, y: (1 + (index * 0.5)), w: Utilities.getPercentageWidth(5, tehsil.total_activity, tehsil.completed_activity), h: 0.3, align: pptx.AlignH.right, color: "ffffff", fontSize: 11, shape: pptx.ShapeType.roundRect, fill: { color: "c9060a" } });
                        newSlide.addText((tehsil.total_activity === 0) ? "0" : tehsil.total_activity, { x: 8.2, y: (1.2 + (index * 0.5)), w: 3, color: "#000000", fontSize: 12 });
                        index++;
                    }
                }
            }
        }

        tehsilDataSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
    }
    static createDataTableSlide(pptx, cropHybrid) {
        let newSlide = pptx.addSlide({ sectionTitle: "Data Table" });
        newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
        newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
        newSlide.addText(cropHybrid.crop_name + " Tehsil wise", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
        newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });


        let rows = [];

        for (var i = 0; i < cropHybrid.data.length; i++) {

            let item = cropHybrid.data[i];
            let tempArray = [];
            tempArray.push(item.tehsil_name);
            for (var j = 0; j < item.hybrid.length; j++) {
                tempArray.push(item.hybrid[j]);
            }
            rows.push(tempArray);

            if ((i + 1) % 6 === 0) {
                newSlide.addTable(rows, { autoPage: true, border: { type: 'solid' }, x: 1.5, w: 7, y: 1.5, rowH: 0.5, align: "center", fontFace: "Arial" });
                newSlide = pptx.addSlide({ sectionTitle: "Sample" });
                newSlide.addImage({ path: "/assets/report-icons/header-img.png", x: 0, y: 0, w: 10, h: 1 });
                newSlide.addImage({ path: "/assets/report-icons/logo.png", x: 0, y: 0, w: 1, h: 0.85 });
                newSlide.addText(cropHybrid.crop_name + " Tehsil wise", { x: 1, y: 0.4, w: 3, color: "#ffffff", bold: true, fontSize: 18 });
                newSlide.addImage({ path: "/assets/report-icons/footer-img.png", x: 0, y: 5, w: 10, h: 0.5 });
                Utilities.LogPrint("okayasd", "splice");
                rows = [];
            }
            if ((i + 1) === cropHybrid.data.length) {
                newSlide.addTable(rows, { autoPage: true, border: { type: 'solid' }, x: 1.5, w: 7, y: 1.5, rowH: 0.5, align: "center", fontFace: "Arial" });
            }
        }
    }


    static roundValue(value) {
        return parseFloat(value).toFixed(2);
    }

    static getLastMonthDate() {
        let date = new Date();
        date.setMonth(date.getMonth() - 3);
        let activityDate = Moment(date).format("YYYY-MM-DD HH:mm:ss");
        Utilities.LogPrint("Activity SYNC", activityDate);
        return activityDate;
    }


    static isVcUser = () => {
        let vc = false;
        const loggedUser = JSON.parse(localStorage.getItem(APP_CONSTANTS.APP_USER));
        if (loggedUser) {
            const user = loggedUser.user;
            if (user?.is_vc) {
                vc = user.is_vc;
            }
        }
        return vc;
    }

    static getDownloadButton(label = "Download", color = "green", size = 16) {
        return `
          <span 
            class="download-button" 
            style="cursor: pointer; align-items: center; gap: 5px;"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="${size}" 
              height="${size}" 
              fill="${color}" 
              class="bi bi-download" 
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2A1.5 1.5 0 0 0 2.5 14h11a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 1 1 0v2A2.5 2.5 0 0 1 13.5 15h-11A2.5 2.5 0 0 1 0 12.5v-2a.5.5 0 0 1 .5-.5z"/>
              <path d="M5.646 7.646a.5.5 0 0 1 .708 0L8 9.293V1.5a.5.5 0 0 1 1 0v7.793l1.646-1.647a.5.5 0 0 1 .708.708l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 0 1 0-.708z"/>
            </svg>
            <u style="color: ${color};">${label}</u>
          </span>
        `;
    }

}